const deletePayGroupDenied = {
    title: 'Ошибка удаления',
    description: 'Нельзя удалить реестр, платежи которого выполнены или находятся в процессе',
    buttonText: 'Понятно',
    mode: 'denied',
} as const;

export default deletePayGroupDenied;
